// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App-logo":"App_App-logo__1GLNd","App-header":"App_App-header__3nnPn","App-link":"App_App-link__TRj1P"};